<h2 mat-dialog-title>Send a form</h2>

<mat-dialog-content class="send-form-dialog">
    <p class="send-form-intro">
        Send a practice form to <strong>{{ patientName }}</strong> to complete.
    </p>

    <ng-container *ngIf="form">
        <form [formGroup]="form" novalidate>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Form</mat-label>
                <mat-select formControlName="customFormId" required>
                    <mat-option *ngFor="let option of availableForms" [value]="option.id">
                        {{ option.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <p class="send-form-hint" *ngIf="availableForms && !availableForms.length">
                This practice has no published forms that can be sent by hand. Publish a form under
                Settings &gt; Forms, and switch on manual sending.
            </p>

            <p class="send-form-hint" *ngIf="selectedForm?.description">
                {{ selectedForm?.description }}
            </p>

            <mat-form-field appearance="outline" class="full-width" *ngIf="groupUsers.length">
                <mat-label>Physician (optional)</mat-label>
                <mat-select formControlName="physicianId">
                    <mat-option [value]="''">No specific physician</mat-option>
                    <mat-option *ngFor="let user of groupUsers" [value]="user.userId">
                        {{ user.title }} {{ user.name }} {{ user.surname }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="send-form-channels">
                <div class="send-form-channels-label">Send by</div>

                <mat-checkbox formControlName="email" [disabled]="!hasEmail">
                    Email
                    <span class="send-form-channel-note" *ngIf="!hasEmail">
                        — no email address on file
                    </span>
                </mat-checkbox>

                <mat-checkbox formControlName="sms" [disabled]="!hasMobile">
                    SMS / WhatsApp
                    <span class="send-form-channel-note" *ngIf="!hasMobile">
                        — no mobile number on file
                    </span>
                </mat-checkbox>
            </div>
        </form>
    </ng-container>

    <!--
        A dedupe refusal. NOT a red error: nothing went wrong, the patient simply already has this
        form or is not due it yet. See the component header.
    -->
    <div class="send-form-blocked" *ngIf="blockedMessage">
        <mat-icon>info</mat-icon>
        <div>
            <div class="send-form-blocked-message">{{ blockedMessage }}</div>
            <button mat-button color="primary" type="button" *ngIf="blockedRequestId"
                (click)="openBlockingRequest()">
                Show that request
            </button>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" [disabled]="!canSend" (click)="send()">
        <mat-spinner *ngIf="sending" diameter="16" mode="indeterminate"></mat-spinner>
        <span *ngIf="!sending">Send</span>
    </button>
</mat-dialog-actions>
